import CheckboxType from './CheckBoxType';

export default CheckboxType;
